import { graphql } from "@/lib/gql/__generated__";

export const UpdateGoogleFreeBookingLinksSettings = graphql(`
	mutation GoogleFreeBookingLinksSettingsUpdate($input: GoogleFreeBookingLinksSettingsInput!) {
		googleFreeBookingLinksSettingsUpdate(input: $input) {
			userErrors
			googleFreeBookingLinksSettings {
				id
				hotelID
				status
				notConnectedReason
				hotelType
				hotelName
				address {
					country
					addr1
					addr2
					addr3
					city
					province
					postalCode
				}
				geoLocation {
					lat
					lon
				}
				webSite
				chillnnGuestPageType
				phoneNumbers {
					phoneType
					phoneNumber
				}
				defaultPlanID
				defaultRoomID
				capacity
				createdAt
				updatedAt
			}
		}
	}
`);
